enum ContactFormType {
  DEFAULT,
  ADVERTISEMENT,
  MEDIA,
}

export default ContactFormType;
